skrilla.directive('queryDeposits', function (constantsService) {
    return {
        templateUrl: 'directives/queryDeposits/queryDeposits.html',
        scope: {
            deposits: "=",
            key: "=",
            queryOverrides: "="
        },
        controller: function ($scope, searchService, queryService, paginationService, cacheService, $stateParams, currencyService) {
            const getDeposits = function () {
                cacheService.registerObject("queryDeposits", $scope.query)
                return searchService.get("deposits" + queryService.getQueryString($scope.query, $scope.key)).then(function (response) {
                    $scope.deposits = response.data.result;
                    $scope.deposits.forEach(function(deposit){
                        deposit.refundStatus = getRefundStatus(deposit)
                        deposit.refundedAmount = deposit.amount - deposit.effectiveAmount
                    })
                    cacheService.registerObject("depositTable", $scope.deposits);
                    paginationService.setPage($scope.key, paginationService.buildPage(response));
                });
            };
            $scope.providerLabels = constantsService.getPaymentProviderLabels();
            const providers = constantsService.getPaymentProviders();

            function getRefundStatus(deposit){
                if(deposit.status  === "REFUNDED") return "YES";
                if(deposit.effectiveAmount < deposit.amount && deposit.status === "PROCESSED") return "PARTIAL";
                return "NO"
            }

            $scope.overrideKeys = function () {
                for(const [key, value] of Object.entries($scope.queryOverrides || {})){
                    $scope.query[key] = value;
                }
            }

            $scope.reset = function () {
                const currencies = currencyService.getCurrencyMap();
                if ($scope.userId) {
                    //if we have a user id return all their deposits
                    Object.keys(currencies).forEach(it => currencies[it] = false)
                }
                $scope.query = {
                    limit: 20,
                    currencies: currencies,
                    providers: providers,
                    statuses: {
                        AWAITING_RESPONSE: false,
                        CANCELLED: false,
                        FAILED: false,
                        PROCESSED: false,
                        CHARGED_BACK: false
                    },
                    showMore: !!$scope.userId,
                    userId: $stateParams.userId
                };
                $scope.overrideKeys()
            };
            $scope.query = cacheService.getObject("queryDeposits")

            if (!$scope.query) {
                $scope.reset();
            }

            $scope.search = function () {
                paginationService.resetPage($scope.key);
                paginationService.pageQuery(getDeposits, $scope.key);
            }


            $scope.btnPress = function (keyEvent) {
                if (keyEvent.which === 13)
                    $scope.search();
            }
        }
    };
});
